<template>
    <div class="edc-stars" :class="{ 'edc-stars--golden': golden }">
        <div class="edc-stars__list">
            <svg
                v-for="(star, idx) in getStars()"
                :key="star + idx"
                :class="`edc-star ${star}`"
                :style="{ width: `${star_size}px`, height: `${star_size}px` }"
                viewBox="0 0 40 40"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                @click="starClicked(idx)"
            >
                <defs v-if="golden && star === 'active'">
                    <linearGradient :id="goldGradientId(idx)" x1="15%" y1="5%" x2="85%" y2="95%">
                        <stop offset="0%" stop-color="#fff6c8" />
                        <stop offset="28%" stop-color="#f2d14a" />
                        <stop offset="55%" stop-color="#d4a017" />
                        <stop offset="82%" stop-color="#a67c0a" />
                        <stop offset="100%" stop-color="#6b4a05" />
                    </linearGradient>
                </defs>
                <path
                    d="M20 32.3391L10.6117 39.4625C10.1465 39.8407 9.63903 40.0194 9.08926 39.9983C8.5395 39.9773 8.05316 39.8197 7.63027 39.5255C7.20737 39.2314 6.87963 38.8321 6.64703 38.3278C6.41444 37.8235 6.40387 37.2771 6.61531 36.6888L10.2311 25.0265L1.03308 18.5335C0.5256 18.1973 0.208428 17.756 0.0815587 17.2097C-0.0453104 16.6633 -0.0241655 16.159 0.144993 15.6967C0.314152 15.2345 0.61018 14.8247 1.03308 14.4675C1.45597 14.1103 1.96345 13.9317 2.55551 13.9317H13.9103L17.5895 1.82814C17.8009 1.23977 18.1287 0.787989 18.5727 0.472794C19.0168 0.157598 19.4925 0 20 0C20.5075 0 20.9832 0.157598 21.4273 0.472794C21.8713 0.787989 22.1991 1.23977 22.4105 1.82814L26.0897 13.9317H37.4445C38.0365 13.9317 38.544 14.1103 38.9669 14.4675C39.3898 14.8247 39.6858 15.2345 39.855 15.6967C40.0242 16.159 40.0453 16.6633 39.9184 17.2097C39.7916 17.756 39.4744 18.1973 38.9669 18.5335L29.7689 25.0265L33.3847 36.6888C33.5961 37.2771 33.5856 37.8235 33.353 38.3278C33.1204 38.8321 32.7926 39.2314 32.3697 39.5255C31.9468 39.8197 31.4605 39.9773 30.9107 39.9983C30.361 40.0194 29.8535 39.8407 29.3883 39.4625L20 32.3391Z"
                    :fill="goldPathFill(star, idx)"
                />
            </svg>
        </div>
    </div>
</template>

<script>
export default {
    name: 'edc-stars',
    props: {
        editable: {
            type: Boolean,
            default: false
        },
        quantity: {
            type: String,
            default: "0.0",
        },
        star_size: {
            type: Number,
            required: false,
            default: 24
        },
        /** Estrellas rellenas en tono dorado (calificaciones mostradas) */
        golden: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            stars: 0,
            /** Evita ids duplicados si hay varios <EDCStars> en la página */
            starScopeId: `g${Math.random().toString(36).slice(2, 10)}`,
        }
    },
    emits: ['star_clicked'],
    methods: {
        goldGradientId(idx) {
            return `edc-star-gold-${this.starScopeId}-${idx}`
        },
        goldPathFill(star, idx) {
            if (!this.golden || star !== 'active') return 'currentColor'
            return `url(#${this.goldGradientId(idx)})`
        },
        getStars() {
            this.stars = parseInt(this.quantity)
            const arr = []

            for (let i = 1; i <= 5; i++) {
                if (i <= this.stars) {
                    arr.push('active')
                } else {
                    arr.push('')
                }
            }

            return arr;
        },
        starClicked(number) {
            // Solo permite interacción cuando está en modo editable (form de reseña)
            if (!this.editable) return
            this.stars = number + 1
            this.$emit('star_clicked', number + 1)
        }
    },
}
</script>

<style>
.edc-stars {
    display: flex;
}

.edc-stars__list {
    display: flex;
    gap: 4px;
}

.edc-star {
    /* Inactivo neutro para no “ensuciar” el diseño */
    color: rgba(0, 0, 0, 0.25);
    opacity: 1;
}

.edc-stars__message {
    color: white;
    font-weight: bold;
    opacity: 0.5;
}

.edc-star.active {
    color: var(--color-primary);
}

/* Dorado con relieve: degradado en el path + sombra suave */
.edc-stars--golden .edc-star.active {
    color: #c9a227;
    filter:
        drop-shadow(0 1px 0 rgba(255, 255, 255, 0.55))
        drop-shadow(0 -1px 0 rgba(80, 55, 8, 0.22))
        drop-shadow(0 2px 3px rgba(120, 90, 15, 0.35));
}
</style>